import { render, staticRenderFns } from "./userCoupon.vue?vue&type=template&id=fc51b4d0&scoped=true"
import script from "./userCoupon.vue?vue&type=script&lang=js"
export * from "./userCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc51b4d0",
  null
  
)

export default component.exports